import React, { useState, useEffect, useMemo, useCallback } from "react";
import { Container, Row, Col, Card, CardHeader, Modal, Form, ModalBody, ModalFooter, ModalHeader, Label, Input, FormFeedback, Button } from '@/Components/ui';;
import { isEmpty } from "lodash";

//Import Breadcrumb
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";

// import TableContainer from "../../../Components/Common/TableContainer";

import { Toaster } from 'react-hot-toast';
import Loader from "../../../Components/Common/Loader";
import { API_TICKETS_CANCELED, getDataFromUrl } from "../../../api";
import ServerPaginatedTable from "../../../Components/Common/ServerPaginatedTable";
import moment from "moment";

const CanceledTicketList = () => {
  const [data, setData] = React.useState([]);
  const [previous, setPrevious] = React.useState("");
  const [next, setNext] = React.useState("");
  const [count, setCount] = React.useState("");

  const onRequestData = (_url) => {
    getDataFromUrl(_url)
      .then((data) => {
        setData(data.results);
        setPrevious(data.previous);
        setNext(data.next);
        setCount(data.count);
        // if (isSearch) calcTotalPageCount(data.count, (data.results).length);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  React.useEffect(() => {
    if (!previous && !next) {
      getDataFromUrl(API_TICKETS_CANCELED)
        .then((data) => {
          // console.log(data);
          setData(data.results);
          setPrevious(data.previous);
          setNext(data.next);
          setCount(data.count);
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }, []);

  const [isEdit, setIsEdit] = useState(false);
  const [customer, setCustomer] = useState([]); // 체크된 유저 리스트

  // Delete customer
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);

  const columns = React.useMemo(
    () => [
      {
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" onClick={() => checkedAll()} />,
        Cell: (cellProps) => {
          return <input type="checkbox" className="customerCheckBox form-check-input" value={cellProps.row.original.id} />;
        },
        id: "#",
      },
      {
        Header: "번호",
        accessor: "row_number",
        id: "",
      },
      // {
      //   Header: 'ID',
      //   accessor: 'id',
      //   id: 'id',
      // },
      /** ["고객", "이름", "상품", "취소일", "취소금액", "row_number"]  */
      {
        Header: "고객번호",
        accessor: "고객",
        id: "order__user__phone_num",
      },
      {
        Header: "성함",
        accessor: "이름",
        id: "order__user__username",
      },
      {
        Header: "티켓상품",
        accessor: "상품",
        id: "ticket_product",
      },
      {
        Header: "취소일",
        accessor: "취소일",
        id: "cancel_date",
        Cell: (cellProps) => {
          return <span>{moment(cellProps.row.original["취소일"]).format("YYYY-MM-DD HH:mm")}</span>;
        },
      },
      {
        Header: "취소금액",
        accessor: "취소금액",
        id: "canceled_amount",
      },
    ],
    []
  );

  const [modal, setModal] = useState(false);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setCustomer(null);
    } else {
      setModal(true);
    }
  }, [modal]);

  // Delete Data
  const onClickDelete = (customer) => {
    setCustomer(customer);
    setDeleteModal(true);
  };

  // Delete Data
  const handleDeleteCustomer = () => {
    if (customer) {
      setDeleteModal(false);
    }
  };

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".customerCheckBox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      // console.log(element.value);
      console.log();
    });
    checkall.checked = false;
  };

  const checkedAll = () => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".customerCheckBox");

    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        {/* 다른 기능을 위한 모달창으로 활용될 수 있음. */}
        <DeleteModal show={deleteModal} onDeleteClick={handleDeleteCustomer} onCloseClick={() => setDeleteModal(false)} />
        <DeleteModal
          show={deleteModalMulti}
          onDeleteClick={() => {
            deleteMultiple();
            setDeleteModalMulti(false);
          }}
          onCloseClick={() => setDeleteModalMulti(false)}
        />

        <Container fluid>
          <BreadCrumb title="사용자티켓 취소" pageTitle="티켓" />
          <Row>
            <Col lg={12}>
              <Card id="customerList">
                <CardHeader className="border-0">
                  <Row className="g-4 align-items-center">
                    <div className="col-sm">
                      <div>
                        <h5 className="card-title mb-0">사용자 티켓 취소 목록</h5>
                      </div>
                    </div>
                    <div className="col-sm-auto">
                      <div>
                        {/* 각 행의 checkbox 또는 전체 checkbox를 선택했을 때 원하는 이벤트 실행을 위한 버튼으로 사용될 수 있음. */}
                        {/* <Button  onClick={() => setDeleteModalMulti(true)} color="soft-danger" className="me-1">
                          <i className="ri-delete-bin-2-line"></i>
                        </Button> */}
                      </div>
                    </div>
                  </Row>
                </CardHeader>

                <div className="card-body pt-0 px-2">
                  <div>
                    <React.Fragment>
                      <ServerPaginatedTable
                        url={API_TICKETS_CANCELED}
                        columns={columns}
                        data={data}
                        previous={previous}
                        next={next}
                        count={count}
                        onRequestData={onRequestData}
                        categories={[
                          { id: 0, title: "전체", search: "", icon: "ri-store-2-fill" },
                          { id: 1, title: "예약완료", search: "", icon: "ri-checkbox-circle-line" },
                          { id: 2, title: "입금대기", search: "", icon: "ri-more-fill" },
                          { id: 3, title: "최소완료", search: "", icon: "ri-arrow-left-right-fill" },
                        ]}
                      />
                    </React.Fragment>
                  </div>
                  <Toaster position="top-center" />
                </div>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default CanceledTicketList;
